import { render, staticRenderFns } from "./add-bank.vue?vue&type=template&id=170a440b&"
import script from "./add-bank.vue?vue&type=script&lang=js&"
export * from "./add-bank.vue?vue&type=script&lang=js&"
import style0 from "./add-bank.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('170a440b', component.options)
    } else {
      api.reload('170a440b', component.options)
    }
    module.hot.accept("./add-bank.vue?vue&type=template&id=170a440b&", function () {
      api.rerender('170a440b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toasts/add-bank.vue"
export default component.exports